import React from "react";
import { withRouter } from "react-router";
import GenericReportChart from "../generics";
import GenderSummaryBox from "./GenderSummaryBox";
import ReturningPieGraph from "./ReturningPieGraph";
import LevelColumnChart from "./StressLevel";
import FrequencyGraphBox from "./FrequencyGraphBox";
// import { history } from "../../../reducers/configureStore";
import i18n from "../../../i18n";
import GenericGraphDrawer, { combineKeyWithCategory } from "../GenericGraphDrawer";
import { OrgUtil, RouteUtil, isAlive } from "../../../util/index";
import { RouteKeys, AttrRouteFormat } from "../../../constants/route";
import { ReportForwardProps, StressTestSupportGraph } from "../../../constants/supportGraph";
import ReportUtil from "../../../util/report";

export const DrawStressGraph = withRouter((props)=>{
	const { typeKey, dateRange, object, previousObject, single, onClick, pushOnTypeClick, history } = props;
	let data = [];
	let def_header = "";
	const pusher = (route, state)=>{
		history.push(route || typeKey, state);//, forwardValue);
	};
	let valuePusher = undefined;
	// console.log(`[${typeKey}].pushOnTypeClick = ${pushOnTypeClick}`,);
	const shareProps = {
		...props,
		timeout: !pushOnTypeClick,
		data: object,
		previousData: previousObject,
		onClick
	};
	switch(typeKey){
	case StressTestSupportGraph.Gender:
		return <GenericReportChart.ReportPieObjectChart 
			{...shareProps}
			header={i18n.t("gender")}
			onHeaderClick={()=>{pusher(RouteKeys.STRESS_BY_GENDER);}}
			onLegendClick={pushOnTypeClick ? (value)=>{
				pusher(RouteKeys.STRESS_BY_GENDER, value);
			} : undefined}
		/>;
	case StressTestSupportGraph.AgeRange:
		return <GenericReportChart.ReportColumnObjectChart
			{...shareProps}
			header={i18n.t("age_range")}
			removeZero={false}
			onHeaderClick={()=>{pusher(RouteKeys.STRESS_BY_AGE);}}
			onLegendClick={pushOnTypeClick ? (value)=>{
				pusher(RouteKeys.STRESS_BY_AGE, value);
			} : undefined}
		/>;
	case StressTestSupportGraph.StressLevel:
		return <LevelColumnChart
			{...shareProps}
			header={i18n.t("stress_level_label")}
			onHeaderClick={()=>{pusher(RouteKeys.STRESS_BY_LEVEL);}}
			onLegendClick={pushOnTypeClick ? (value)=>{
				pusher(RouteKeys.STRESS_BY_LEVEL, value);
			} : undefined}
		/>;
	case StressTestSupportGraph.Returning:
		return <ReturningPieGraph 
			{...shareProps}
			header={i18n.t("returning_user")}
			onHeaderClick={()=>{pusher(RouteKeys.STRESS_BY_RETURNING);}}
			onLegendClick={pushOnTypeClick ? (value)=>{
				pusher(RouteKeys.STRESS_BY_RETURNING, value);
			} : undefined}
		/>;
	case StressTestSupportGraph.Frequency:
		/**
		 * Frequency not support any onclick because it doesn't has it own page.
		 */
		return <FrequencyGraphBox
			{...props}
			data={object}
			dateRange={dateRange}
		/>;
	default:
		if(isAlive(typeKey)){
			const catNames = Array.from(OrgUtil.getAllCategoryName(), k=>k.toLowerCase());
			if(catNames.indexOf(typeKey.toLowerCase())!==-1){
				const routeKey = RouteUtil.CreateCategoryRouteKeyByName(typeKey.toLowerCase(), AttrRouteFormat.STRESS);
				return <GenericReportChart.ReportCatgoryChart 
					{...shareProps}
					category_name={typeKey}
					onHeaderClick={()=>{pusher(routeKey);}}
					onLegendClick={pushOnTypeClick ? (value)=>{
						console.log(`[${routeKey}].value: `,value);
						pusher(routeKey, value);
					} : undefined}
				/>;
			}else{
				console.warn(`no category [ ${typeKey} ] found in organize.`);
				return null;
			}
		}else{
			console.warn("Require property 'typeKey' to pick a graph to draw.");
			return null;
		}
	}
});

export default (props)=>{
	const { summary, previousSummary, colorType } = props;
	// console.log(`[${colorType}] stress before mutate: `,{summary, previousSummary});
	return <GenericGraphDrawer
		{...props}
		supportGraphKeys={Object.values(StressTestSupportGraph).concat(OrgUtil.getAllCategoryName())}
		mutateSummary={summary}
		mutatePreviousSummary={previousSummary} 
		drawEach={DrawStressGraph}
	/>;
};
DrawStressGraph.defaultProps = {
	typeKey:        undefined,
	object:         undefined,
	previousObject: undefined,
	height:         undefined,
	colorType:      undefined,
	onClick:        undefined, 
	header:         "HEADER", 

	isVertical:     false,
	short:          false,
	clickHeader:    false,
	showLegend:     true,
	showValue:      true,
};

export { GenderSummaryBox };


// WEBPACK FOOTER //
// ./src/components/report/stress/index.js